import React from 'react'
import { ChevronRight, Folder } from 'lucide-react'
import { useCreationText } from '../../hooks/useCreationText'
import { PreviewTitle } from '../SubtaskPreviewCard/PreviewTitle'
import styles from './styles.module.css'

interface ISubtaskCategoryHeaderProps {
  category?: string
  title?: string
  children: React.ReactNode
}

export function SubtaskCategoryHeader({ category, title, children }: ISubtaskCategoryHeaderProps) {
  const t = useCreationText()

  return (
    <header className={category ? styles.header : undefined}>
      {category ? (
        <>
          <div className={styles.breadcrumb} role="group" aria-label={t.category}>
            <span className={styles.label}>{t.category}</span>
            <span className={styles.category} title={category}>
              <Folder size={18} aria-hidden="true" />
              <span>{category}</span>
            </span>
            <ChevronRight className={styles.separator} size={18} aria-hidden="true" />
            <span className={styles.title}>
              <PreviewTitle value={title} fallback={t.untitled} />
            </span>
          </div>
          <div className={styles.content}>{children}</div>
        </>
      ) : (
        children
      )}
    </header>
  )
}
